import { parse } from "svg-parser";
export const getSvgDimensions = svg => {
  var _rootChild$properties, _rootChild$properties2, _rootChild$properties3;

  const parsed = parse(svg);
  const rootChild = parsed.children[0];
  return {
    width: parseInt(String(((_rootChild$properties = rootChild.properties) === null || _rootChild$properties === void 0 ? void 0 : _rootChild$properties.width) ?? "0")),
    height: parseInt(String(((_rootChild$properties2 = rootChild.properties) === null || _rootChild$properties2 === void 0 ? void 0 : _rootChild$properties2.height) ?? "0")),
    viewBox: String(((_rootChild$properties3 = rootChild.properties) === null || _rootChild$properties3 === void 0 ? void 0 : _rootChild$properties3.viewBox) ?? "")
  };
};
//# sourceMappingURL=svg.js.map